import { GET_POLYGON_REGION, GET_POLYGON_REGION_SUCCESS, GET_POLYGON_REGION_ERROR, GET_POLYGON_REGION_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetPolygonRegion = (state = initialState, action) => {
  switch (action.type) {
    case GET_POLYGON_REGION:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_POLYGON_REGION_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_POLYGON_REGION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_POLYGON_REGION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetPolygonRegion;
